import semverSatisfies from 'semver/functions/satisfies';

export function minimalRequiredRuntimeCheck({
  packageJson,
  required,
  requiredBy = 'Cairo',
}: {
  packageJson: { name: string; version: string };
  required: string;
  requiredBy?: string;
}) {
  const { version: actual, name: packageName } = packageJson;

  const satisfies =
    actual.startsWith('0.0.0') || semverSatisfies(actual, required);

  if (!satisfies) {
    throw new Error(
      `[@wix/cairo]: ${packageName}@${actual} does not satisfy ${requiredBy} minimal requirement: ${required}`,
    );
  }
}
